import {handleActions, Action} from 'redux-actions';

import {ThumbnailMarker} from '../../../Timeline/TimelineTypes';
import {
    THUMBNAILS_SET,
    THUMBNAILS_RESET,
    ThumbnailsPayload,
} from './ThumbnailsActions';

export interface ThumbnailsState {
    markers: ThumbnailMarker[];
}

export const mapToId = (item: ThumbnailMarker) => {
    return item.identifier;
};

export const getNewMarkersState = (markers: ThumbnailMarker[], newMarkers: ThumbnailMarker[] | null, existedIds: string[]) => {
    const newMarkersState = Array.from(markers);
    
    if (newMarkers) {
        for (const item of newMarkers) {
            if (!existedIds.includes(item.identifier)) {
                newMarkersState.push(item);
            }
        }
    }
    
    return newMarkersState;
};

export const setThumbnails = (state: ThumbnailsState, {payload}: Action<ThumbnailsPayload>): ThumbnailsState => {
    const newMarkers = payload;
    const {markers} = state;
    const existedIds = markers.map(mapToId);
    const newMarkersState = getNewMarkersState(markers, newMarkers, existedIds);
    
    if (newMarkers)
        return {
            markers: newMarkersState,
        };
    
    return state;
};

export const resetThumbnails = (): ThumbnailsState => {
    return initialState;
};

export const initialState: ThumbnailsState = {
    markers: [],
};

const handlers = {
    [THUMBNAILS_SET]: setThumbnails,
    [THUMBNAILS_RESET]: resetThumbnails,
};

type CombinedPayloads = ThumbnailsPayload;

export default handleActions<ThumbnailsState, CombinedPayloads>(handlers, initialState);
